// ═══════════════════════════════════════════════════════════════
// LandingPage — replica de easyrural.net (home + subpáginas + login + register)
// Totalmente traducido a ES / CA / EN / FR mediante useT().
// ═══════════════════════════════════════════════════════════════
import { useState } from "react";
import { useLang, useT, SUPPORTED_LANGS } from "./i18n";
import { DEMO_USERS, findUser } from "./demoUsers";

const C = {
  brand: "#406020",
  bdark: "#283226",
  lightbrand: "#EBF2E4",
  light: "#F5F7F0",
  dark: "#4B4B4B",
  white: "#fff",
};
const FONT_BODY = "'Baloo 2', sans-serif";
const FONT_BABY = "'Oooh Baby', cursive";

const btnBrand = { display: "inline-block", border: `1px solid ${C.brand}`, background: C.brand, color: "#fff", fontFamily: FONT_BODY, fontSize: 18, fontWeight: 600, padding: "8px 24px", borderRadius: 9999, cursor: "pointer", textDecoration: "none" };
const btnOutline = { ...btnBrand, background: "transparent", color: C.brand };
const btnWhite = { ...btnBrand, background: "#fff", color: C.brand, border: "1px solid #fff" };
const container = { maxWidth: 1280, margin: "0 auto", padding: "0 20px" };
const h2 = { color: C.bdark, fontSize: 36, lineHeight: 1.2, fontWeight: 700, fontFamily: FONT_BODY, margin: 0 };
const h2Brand = { ...h2, color: C.brand };

// ═══════════ HEADER ═════════════════════════════════════════════
function Header({ currentPage, setPage, onAccess, onRegister }) {
  const t = useT();
  const [funcOpen, setFuncOpen] = useState(false);
  const { lang, setLang } = useLang();
  const [langOpen, setLangOpen] = useState(false);

  const isActive = (id) => currentPage === id;
  const navLink = (id, label) => (
    <button onClick={() => { setPage(id); setFuncOpen(false); }}
      style={{ background: "transparent", border: "none", cursor: "pointer", fontFamily: FONT_BODY, fontSize: 17, fontWeight: 700, color: isActive(id) ? C.brand : C.bdark, padding: "8px 4px" }}
      onMouseEnter={(e) => e.currentTarget.style.color = C.brand}
      onMouseLeave={(e) => e.currentTarget.style.color = isActive(id) ? C.brand : C.bdark}>
      {label}
    </button>
  );

  const FUNCIONALIDADES = [
    { id: "reservas", label: t("land.nav.gestionReservas") },
    { id: "facturacion", label: t("land.nav.gestionFacturacion") },
    { id: "huespedes", label: t("land.nav.gestionHuespedes") },
    { id: "motor", label: t("land.nav.motorReservas") },
  ];

  return (
    <header style={{ background: C.white, width: "100%", position: "sticky", top: 0, zIndex: 50, borderBottom: "1px solid #F0F0F0" }}>
      <nav style={{ ...container, padding: "10px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 24 }}>
        <button onClick={() => setPage("home")} style={{ background: "transparent", border: "none", cursor: "pointer", padding: 0, flexShrink: 0 }}>
          <img src="/easyrural-logo.png" alt="EasyRural" style={{ height: 50, width: "auto", display: "block" }} />
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: 26, flex: 1, justifyContent: "center" }}>
          <div style={{ position: "relative" }} onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setFuncOpen((v) => !v)}
              style={{ background: "transparent", border: "none", cursor: "pointer", fontFamily: FONT_BODY, fontSize: 17, fontWeight: 700, color: FUNCIONALIDADES.some((f) => f.id === currentPage) ? C.brand : C.bdark, display: "flex", alignItems: "center", gap: 4 }}>
              {t("land.nav.funcionalidades")} <span style={{ fontSize: 10 }}>{funcOpen ? "▲" : "▼"}</span>
            </button>
            {funcOpen && (
              <div style={{ position: "absolute", top: "100%", left: 0, marginTop: 8, background: C.white, boxShadow: "0 4px 14px rgba(0,0,0,0.12)", borderRadius: 6, minWidth: 280, padding: "6px 0", zIndex: 100 }}>
                {FUNCIONALIDADES.map((f) => (
                  <button key={f.id} onClick={() => { setPage(f.id); setFuncOpen(false); }}
                    style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 18px", border: "none", background: isActive(f.id) ? "#F5F7F0" : "transparent", color: isActive(f.id) ? C.brand : C.bdark, fontFamily: FONT_BODY, fontSize: 15, fontWeight: 500, cursor: "pointer" }}
                    onMouseEnter={(e) => e.currentTarget.style.background = "#F5F7F0"}
                    onMouseLeave={(e) => e.currentTarget.style.background = isActive(f.id) ? "#F5F7F0" : "transparent"}>
                    {f.label}
                  </button>
                ))}
              </div>
            )}
          </div>
          {navLink("precios", t("land.nav.precio"))}
          {navLink("equipo", t("land.nav.equipo"))}
          {navLink("faqs", t("land.nav.faqs"))}
          {navLink("contacto", t("land.nav.contacto"))}
          {navLink("blog", t("land.nav.blog"))}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
          <div style={{ position: "relative" }} onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setLangOpen((v) => !v)}
              style={{ background: "transparent", border: "none", cursor: "pointer", fontFamily: FONT_BODY, fontSize: 17, fontWeight: 700, color: C.bdark, display: "flex", alignItems: "center", gap: 4 }}>
              {lang.charAt(0).toUpperCase() + lang.slice(1)} <span style={{ fontSize: 10 }}>▼</span>
            </button>
            {langOpen && (
              <div style={{ position: "absolute", top: "100%", right: 0, marginTop: 4, background: C.white, boxShadow: "0 4px 12px rgba(0,0,0,0.12)", minWidth: 96, padding: "6px 0", borderRadius: 4 }}>
                {SUPPORTED_LANGS.map((l) => (
                  <button key={l.code} onClick={() => { setLang(l.code); setLangOpen(false); }}
                    style={{ display: "block", width: "100%", textAlign: "left", padding: "8px 18px", border: "none", background: lang === l.code ? "#EBF2E4" : "transparent", color: lang === l.code ? C.brand : C.bdark, fontFamily: FONT_BODY, fontSize: 15, fontWeight: 600, cursor: "pointer" }}>
                    {l.code.charAt(0).toUpperCase() + l.code.slice(1)}
                  </button>
                ))}
              </div>
            )}
          </div>
          <button onClick={onAccess} style={{ ...btnOutline, fontSize: 15 }}
            onMouseEnter={(e) => { e.currentTarget.style.background = C.brand; e.currentTarget.style.color = "#fff"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = C.brand; }}>
            {t("land.nav.acceder")}
          </button>
          <button onClick={onRegister || onAccess} style={{ ...btnBrand, fontSize: 15 }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = C.brand; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = C.brand; e.currentTarget.style.color = "#fff"; }}>
            {t("land.nav.pruebaGratuita")}
          </button>
        </div>
      </nav>
    </header>
  );
}

// ═══════════ FOOTER ═════════════════════════════════════════════
function Footer() {
  const t = useT();
  return (
    <footer style={{ background: C.dark, color: "#fff", padding: "60px 20px 30px", fontFamily: FONT_BODY, marginTop: "auto" }}>
      <div style={{ ...container, display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 32, marginBottom: 30 }}>
        <div>
          <img src="/easyrural-logo.png" alt="EasyRural" style={{ height: 50, width: "auto", display: "block", filter: "brightness(0) invert(1)" }} />
          <div style={{ marginTop: 18, fontSize: 14 }}>{t("land.foot.derechos")}</div>
          <div style={{ marginTop: 20, display: "flex", gap: 12, fontSize: 14 }}>
            {[["IG", "https://www.instagram.com/easyrural/"], ["FB", "https://www.facebook.com/easyrural"], ["in", "https://www.linkedin.com/company/easyrural/"], ["X", "https://twitter.com/EasyRural"], ["Wa", "https://wa.me/34649133541"]].map(([l, h]) => (
              <a key={l} href={h} target="_blank" rel="noreferrer"
                style={{ color: "#fff", textDecoration: "none", width: 32, height: 32, borderRadius: "50%", border: "1px solid rgba(255,255,255,0.3)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700 }}>
                {l}
              </a>
            ))}
          </div>
        </div>
        <div>
          <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 16 }}>{t("land.foot.soporteTecnico")}</div>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: 14, lineHeight: 1.6 }}>
            <li>📧 <a href="mailto:info@easyrural.net" style={{ color: "#fff", fontWeight: 700, textDecoration: "none" }}>info@easyrural.net</a><div style={{ fontWeight: 300, fontSize: 13 }}>{t("land.foot.soporteOnline")}</div></li>
            <li style={{ marginTop: 12 }}>📞 <a href="tel:+34649133541" style={{ color: "#fff", fontWeight: 700, textDecoration: "none" }}>+34 649 13 35 41</a><div style={{ fontWeight: 300, fontSize: 13 }}>{t("land.foot.de8a14")}</div></li>
          </ul>
        </div>
        <div>
          <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 16 }}>{t("land.foot.infoLegal")}</div>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: 14, lineHeight: 2 }}>
            {[
              [t("land.foot.politicaPriv"), "https://easyrural.net/es/politica-de-privacidad.html"],
              [t("land.foot.politicaCookies"), "https://easyrural.net/es/politica-de-cookies.html"],
              [t("land.foot.terminos"), "https://easyrural.net/es/terminos-y-condiciones.html"],
              [t("land.foot.avisoLegal"), "https://easyrural.net/es/aviso-legal.html"],
            ].map(([txt, h]) => (
              <li key={txt}><a href={h} target="_blank" rel="noreferrer" style={{ color: "#fff", textDecoration: "none", fontWeight: 300 }}>{txt}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 16 }}>{t("land.foot.masInfo")}</div>
          <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: 14, lineHeight: 2 }}>
            <li><a href="https://easyrural.net" target="_blank" rel="noreferrer" style={{ color: "#fff", textDecoration: "none", fontWeight: 300 }}>{t("land.foot.acerca")}</a></li>
            <li style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid rgba(255,255,255,0.15)" }}>
              <div style={{ fontWeight: 600 }}>{t("land.foot.moduloEnergia")}</div>
              <div style={{ fontSize: 12, fontWeight: 300, marginTop: 4 }}>{t("land.foot.upcDih")}</div>
            </li>
          </ul>
        </div>
      </div>
      <div style={{ textAlign: "center", fontSize: 11, opacity: 0.6, marginTop: 20 }}>{t("land.foot.replica")}</div>
    </footer>
  );
}

// ═══════════ BANNER GRATIS (reutilizable) ═══════════════════════
function BannerGratis({ onAccess }) {
  const t = useT();
  return (
    <section style={{ background: C.brand, color: "#fff", padding: "60px 20px" }}>
      <div style={{ ...container, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60, alignItems: "center" }}>
        <div><img src="/landing/uploads_1200x745_c_rogsdcgiexv.png" alt="EasyRural" style={{ width: "100%", height: "auto" }} /></div>
        <div>
          <h2 style={{ ...h2, color: "#fff" }}>{t("land.banner.title")}</h2>
          <p style={{ fontSize: 20, lineHeight: 1.4, marginTop: 18, fontFamily: FONT_BODY }}>{t("land.banner.desc")}</p>
          <div style={{ marginTop: 24 }}>
            <button onClick={onAccess} style={{ ...btnWhite, fontSize: 20, padding: "12px 32px", fontWeight: 700, border: "none", cursor: "pointer" }}>{t("land.hero.empiezaGratis")}</button>
          </div>
        </div>
      </div>
    </section>
  );
}

// ═══════════ HOME ═══════════════════════════════════════════════
function HomePage({ onAccess }) {
  const t = useT();
  const logos = ["3.png", "1.png", "2.png", "5.png", "4.png", "llerau2.png", "calaliu.png"];

  return (
    <>
      {/* HERO */}
      <section style={{ background: C.brand, color: "#fff", padding: "40px 20px 60px" }}>
        <div style={{ ...container, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60, alignItems: "center" }}>
          <div>
            <div style={{ fontSize: 70, lineHeight: 1.05, fontFamily: FONT_BODY }}>
              <div><span style={{ fontWeight: 700 }}>{t("land.hero.rural")} </span><span style={{ fontFamily: FONT_BABY, fontSize: 90 }}>{t("land.hero.si")}</span></div>
              <div><span style={{ fontWeight: 700 }}>{t("land.hero.digital")} </span><span style={{ fontFamily: FONT_BABY, fontSize: 90 }}>{t("land.hero.tambien")}</span></div>
            </div>
            <div style={{ fontWeight: 700, fontSize: 28, lineHeight: 1.25, marginTop: 22, fontFamily: FONT_BODY }}>{t("land.hero.pms")}</div>
            <div style={{ fontSize: 20, lineHeight: 1.4, marginTop: 18, fontFamily: FONT_BODY }}>{t("land.hero.intro")}</div>
            <div style={{ marginTop: 28 }}>
              <button onClick={onAccess} style={{ ...btnWhite, fontSize: 22, padding: "12px 32px", fontWeight: 700, border: "none", cursor: "pointer" }}>{t("land.hero.empiezaGratis")}</button>
            </div>
          </div>
          <div><img src="/landing/uploads_900x548_c_allotjmanet-habitacions-mockup.png" alt="EasyRural" style={{ width: "100%", height: "auto" }} /></div>
        </div>
      </section>

      {/* 3 funcionalidades */}
      <section style={{ padding: "60px 20px", ...container }}>
        <div style={{ textAlign: "center", maxWidth: 820, margin: "0 auto" }}>
          <h1 style={{ ...h2Brand, fontSize: 38, fontWeight: 700 }}>{t("land.home.gestionaTitle")}</h1>
          <p style={{ marginTop: 18, fontSize: 20, lineHeight: 1.4, color: C.bdark, fontFamily: FONT_BODY }}>{t("land.home.gestionaSub")}</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 32, marginTop: 48 }}>
          {[
            { icon: "uploads_icons_400x400_c_llaves.png", t: t("land.home.fn1.t"), d: t("land.home.fn1.d") },
            { icon: "uploads_icons_400x400_c_factura.png", t: t("land.home.fn2.t"), d: t("land.home.fn2.d") },
            { icon: "uploads_icons_400x400_c_crm.png", t: t("land.home.fn3.t"), d: t("land.home.fn3.d") },
          ].map((c) => (
            <div key={c.t} style={{ background: C.lightbrand, borderRadius: 12, padding: 24, display: "flex", flexDirection: "column" }}>
              <img src={`/landing/${c.icon}`} alt={c.t} style={{ width: 80, margin: "0 auto", display: "block" }} />
              <h3 style={{ textAlign: "center", marginTop: 16, color: C.brand, fontSize: 24, fontFamily: FONT_BODY, fontWeight: 700 }}>{c.t}</h3>
              <p style={{ marginTop: 12, fontSize: 17, color: C.bdark, fontFamily: FONT_BODY, flex: 1, lineHeight: 1.45 }}>{c.d}</p>
              <div style={{ marginTop: 16, textAlign: "center" }}>
                <button style={{ ...btnBrand, fontSize: 15, border: "none", cursor: "pointer" }}>{t("land.home.saberMas")}</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Adaptado */}
      <section style={{ padding: "40px 20px", ...container }}>
        <div style={{ textAlign: "center", maxWidth: 820, margin: "0 auto" }}>
          <h2 style={h2Brand}>{t("land.home.adaptadoTitle")}</h2>
          <p style={{ marginTop: 18, fontSize: 20, lineHeight: 1.4, color: C.bdark, fontFamily: FONT_BODY }}>{t("land.home.adaptadoSub")}</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32, marginTop: 40 }}>
          {[
            { icon: "uploads_icons_400x400_c_cabina.png", t: t("land.home.alqCompleto.t"), d: t("land.home.alqCompleto.d") },
            { icon: "uploads_icons_400x400_c_cama-matrimonial.png", t: t("land.home.alqHab.t"), d: t("land.home.alqHab.d") },
          ].map((c) => (
            <div key={c.t} style={{ background: C.light, borderRadius: 14, padding: "32px 24px", display: "grid", gridTemplateColumns: "auto 1fr", gap: 24, alignItems: "center" }}>
              <img src={`/landing/${c.icon}`} alt={c.t} style={{ height: 100, width: "auto" }} />
              <div>
                <h3 style={{ color: C.brand, fontSize: 24, fontFamily: FONT_BODY, fontWeight: 700, margin: 0 }}>{c.t}</h3>
                <p style={{ marginTop: 12, fontSize: 17, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.45 }}>{c.d}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 6 razones */}
      <section style={{ background: C.lightbrand, padding: "80px 20px" }}>
        <div style={container}>
          <div style={{ textAlign: "center", maxWidth: 820, margin: "0 auto" }}>
            <h2 style={h2Brand}>{t("land.home.porqueTitle")}</h2>
            <p style={{ marginTop: 12, fontSize: 20, lineHeight: 1.4, color: C.bdark, fontFamily: FONT_BODY }}>{t("land.home.porqueSub")}</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 24, marginTop: 48 }}>
            {[
              { icon: "uploads_icons_400x400_c_cebada.png", t: t("land.home.r1.t"), d: t("land.home.r1.d") },
              { icon: "uploads_icons_400x400_c_facil-de-usar.png", t: t("land.home.r2.t"), d: t("land.home.r2.d") },
              { icon: "uploads_icons_400x400_c_reloj-de-arena.png", t: t("land.home.r3.t"), d: t("land.home.r3.d") },
              { icon: "uploads_icons_400x400_c_juez.png", t: t("land.home.r4.t"), d: t("land.home.r4.d") },
              { icon: "uploads_icons_400x400_c_computacion-en-la-nube.png", t: t("land.home.r5.t"), d: t("land.home.r5.d") },
              { icon: "uploads_icons_400x400_c_sincronizar.png", t: t("land.home.r6.t"), d: t("land.home.r6.d") },
            ].map((r) => (
              <div key={r.t} style={{ background: "#fff", borderRadius: 14, padding: 28 }}>
                <img src={`/landing/${r.icon}`} alt={r.t} style={{ height: 80, margin: "0 auto", display: "block" }} />
                <h3 style={{ marginTop: 14, textAlign: "center", color: C.brand, fontSize: 22, fontFamily: FONT_BODY, fontWeight: 700 }}>{r.t}</h3>
                <p style={{ marginTop: 12, fontSize: 17, color: "#000", fontFamily: FONT_BODY, lineHeight: 1.45 }}>{r.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5 features destacadas */}
      <section style={{ background: C.lightbrand, padding: "60px 20px" }}>
        <div style={container}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32 }}>
            {[
              { icon: "uploads_icons_400x400_c_llaves.png", t: t("land.home.f1.t"), d: t("land.home.f1.d") },
              { icon: "uploads_icons_400x400_c_factura.png", t: t("land.home.f2.t"), d: t("land.home.f2.d") },
              { icon: "uploads_icons_400x400_c_sincronizar.png", t: t("land.home.f3.t"), d: t("land.home.f3.d") },
              { icon: "uploads_icons_400x400_c_crm.png", t: t("land.home.f4.t"), d: t("land.home.f4.d") },
              { icon: "uploads_icons_400x400_c_factura.png", t: t("land.home.f5.t"), d: t("land.home.f5.d") },
            ].map((f) => (
              <div key={f.t} style={{ background: "#fff", borderRadius: 14, padding: 24, display: "grid", gridTemplateColumns: "auto 1fr", gap: 18, alignItems: "center" }}>
                <img src={`/landing/${f.icon}`} alt={f.t} style={{ height: 80, width: 80, objectFit: "contain" }} />
                <div>
                  <div style={{ color: C.brand, fontSize: 22, fontWeight: 700, fontFamily: FONT_BODY }}>{f.t}</div>
                  <p style={{ marginTop: 8, fontSize: 16, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.45 }}>{f.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Visibilidad */}
      <section style={{ padding: "60px 20px", ...container }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32, alignItems: "center" }}>
          <div>
            <h2 style={h2Brand}>{t("land.home.visibilidadTitle")}</h2>
            <p style={{ marginTop: 18, fontSize: 19, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.4 }}>{t("land.home.visibilidad1")}</p>
            <p style={{ marginTop: 14, fontSize: 19, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.4 }}>{t("land.home.visibilidad2")}</p>
          </div>
          <div style={{ background: C.lightbrand, borderRadius: 16, padding: 50, textAlign: "center" }}>
            <div style={{ fontSize: 60, color: C.brand, fontWeight: 700, fontFamily: FONT_BODY }}>+100</div>
            <div style={{ marginTop: 8, fontSize: 22, color: C.bdark, fontFamily: FONT_BODY, fontWeight: 600 }}>{t("land.home.portalesConect")}</div>
            <div style={{ marginTop: 28, display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center", color: C.brand, fontFamily: FONT_BODY, fontWeight: 600 }}>
              {["Booking", "Airbnb", "VRBO", "Expedia", "TripAdvisor", "HomeAway"].map((p) => (
                <span key={p} style={{ background: "#fff", padding: "8px 16px", borderRadius: 9999, fontSize: 15 }}>{p}</span>
              ))}
            </div>
            <div style={{ marginTop: 18, color: C.brand, fontWeight: 700, fontFamily: FONT_BODY, fontSize: 18 }}>{t("land.home.entreOtros")}</div>
          </div>
        </div>
      </section>

      <BannerGratis onAccess={onAccess} />

      {/* Clientes */}
      <section style={{ padding: "60px 20px", ...container }}>
        <h2 style={{ ...h2Brand, textAlign: "center", fontSize: 32 }}>{t("land.home.confianTitle")}</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 24, marginTop: 40, alignItems: "center" }}>
          {logos.map((l) => (<div key={l} style={{ display: "flex", justifyContent: "center" }}><img src={`/landing/${l}`} alt={l} style={{ maxHeight: 90, width: "auto" }} /></div>))}
        </div>
      </section>

      {/* Testimonios */}
      <section style={{ background: "rgba(0,0,0,0.04)", padding: "60px 20px" }}>
        <div style={container}>
          <h2 style={{ ...h2Brand, textAlign: "center", fontSize: 32 }}>{t("land.home.opinanTitle")}</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24, marginTop: 40 }}>
            {[
              { t: t("land.home.test1.t"), q: t("land.home.test1.q"), a: "Eduard González", o: "Refugi Pleta del Prat" },
              { t: t("land.home.test2.t"), q: t("land.home.test2.q"), a: "Marta Dalmau", o: "Masía Can Orta" },
              { t: t("land.home.test3.t"), q: t("land.home.test3.q"), a: "Alicia Pérez", o: "Apartaments Cel i Fusta" },
              { t: t("land.home.test4.t"), q: t("land.home.test4.q"), a: "Jordi Castelló", o: "Masía Can Mulo" },
            ].map((ts) => (
              <div key={ts.a} style={{ background: "#fff", borderRadius: 14, padding: 28 }}>
                <div style={{ color: C.brand, fontSize: 22, fontWeight: 700, fontFamily: FONT_BODY }}>{ts.t}</div>
                <p style={{ marginTop: 14, fontSize: 17, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.45, fontStyle: "italic" }}>"{ts.q}"</p>
                <div style={{ marginTop: 18, paddingTop: 16, borderTop: `1px solid ${C.lightbrand}` }}>
                  <div style={{ color: C.brand, fontWeight: 700, fontFamily: FONT_BODY, fontSize: 17 }}>{ts.a}</div>
                  <div style={{ color: C.bdark, fontFamily: FONT_BODY, fontSize: 14, marginTop: 2 }}>{ts.o}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

// ═══════════ PLACEHOLDER PAGES (Precios, Equipo, FAQs, Contacto, Blog, Funcionalidades) ═══
// Estos componentes están migrados parcialmente. La PARTE 2 del i18n acaba el contenido detallado.
// Por ahora muestran los titulares traducidos + contenido estructural.

// ═══════════ PRECIOS ════════════════════════════════════════════
function PreciosPage({ onAccess }) {
  const t = useT();
  const [tab, setTab] = useState(0);
  const featBasic = [t("land.pre.feat1"), t("land.pre.feat2"), t("land.pre.feat3"), t("land.pre.feat4"), t("land.pre.feat5"), t("land.pre.feat6"), t("land.pre.feat7"), t("land.pre.feat8")];
  const featRoom = [...featBasic, t("land.pre.feat9"), t("land.pre.feat10")];

  const PriceCard = ({ intro, priceMonth, priceMonthOld, priceYear, priceYearOld, features, fromText }) => (
    <div style={{ background: C.light, borderRadius: 14, padding: 32, flex: 1, maxWidth: 560, display: "flex", flexDirection: "column" }}>
      <div style={{ color: C.brand, textAlign: "center", fontSize: 32, lineHeight: 1.2, fontWeight: 600, fontFamily: FONT_BODY }}>{t("land.pre.planBasico")}</div>
      <div style={{ fontWeight: 700, fontSize: 18, textAlign: "center", marginTop: 10, color: C.bdark, fontFamily: FONT_BODY }}>{intro}</div>
      <div style={{ display: "flex", justifyContent: "space-around", margin: "24px 0", gap: 16 }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 13, textDecoration: "line-through", color: "#777" }}>{priceMonthOld} €</div>
          <div style={{ fontSize: 38, fontWeight: 700, color: C.bdark, fontFamily: FONT_BODY }}>{fromText && <span style={{ fontSize: 14, fontWeight: 500 }}>{t("land.pre.desde")} </span>}{priceMonth} <span style={{ fontSize: 14, fontWeight: 600 }}>{t("land.pre.mes")}</span></div>
          <div style={{ fontSize: 13, color: C.bdark, marginTop: 4 }}>{t("land.pre.durante3")}</div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 13, textDecoration: "line-through", color: "#777" }}>{priceYearOld} €</div>
          <div style={{ fontSize: 38, fontWeight: 700, color: C.bdark, fontFamily: FONT_BODY }}>{fromText && <span style={{ fontSize: 14, fontWeight: 500 }}>{t("land.pre.desde")} </span>}{priceYear} <span style={{ fontSize: 14, fontWeight: 600 }}>{t("land.pre.anio")}</span></div>
          <div style={{ fontSize: 13, color: C.bdark, marginTop: 4 }}>{t("land.pre.descuento15")}</div>
        </div>
      </div>
      <hr style={{ border: "none", borderTop: "1px solid #E0E0E0", margin: "12px 0" }} />
      <div style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}>
        {features.map((f, i) => (
          <div key={i} style={{ display: "flex", gap: 12, alignItems: "center", fontSize: 17, color: C.bdark, fontFamily: FONT_BODY }}>
            <img src="/landing/fe_check.png" alt="✓" style={{ width: 24, height: 24, flexShrink: 0 }} />
            {f}
          </div>
        ))}
      </div>
      <div style={{ marginTop: 16 }}>
        <img src="/landing/kdd.png" alt="Kit Digital" style={{ width: "100%", filter: "grayscale(1)" }} />
        <div style={{ marginTop: 6, fontSize: 13, color: "#000" }}>{t("land.pre.kitDigital")}</div>
      </div>
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <button onClick={onAccess} style={{ ...btnBrand, fontSize: 17, border: "none", cursor: "pointer" }}>{t("land.nav.pruebaGratuita")}</button>
      </div>
    </div>
  );

  return (
    <>
      <section style={{ padding: "60px 20px", ...container }}>
        <div style={{ textAlign: "center", maxWidth: 920, margin: "0 auto" }}>
          <h1 style={{ ...h2, fontSize: 32, fontWeight: 700 }}>{t("land.pre.title")} <span style={{ color: C.brand }}>{t("land.pre.welcome")}</span> {t("land.pre.titleEnd")}</h1>
          <p style={{ marginTop: 18, fontSize: 18, color: C.bdark, fontFamily: FONT_BODY }}><strong>{t("land.pre.intro")}</strong></p>
          <p style={{ marginTop: 8, fontSize: 16, color: C.bdark, fontFamily: FONT_BODY }}>{t("land.pre.tipo")}</p>
        </div>
        <div style={{ display: "flex", background: "rgba(0,0,0,0.06)", borderRadius: 12, padding: 6, maxWidth: 520, margin: "32px auto 0" }}>
          {[t("land.pre.completo"), t("land.pre.habitaciones")].map((label, i) => (
            <button key={label} onClick={() => setTab(i)} style={{ flex: 1, padding: "14px 8px", border: "none", borderRadius: 10, background: tab === i ? "#fff" : "transparent", color: C.brand, fontFamily: FONT_BODY, fontSize: 18, fontWeight: 700, cursor: "pointer" }}>{label}</button>
          ))}
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: 32, marginTop: 40, flexWrap: "wrap" }}>
          {tab === 0 ? (
            <PriceCard intro={t("land.pre.planBasicoSub")} priceMonth="7,5" priceMonthOld="15" priceYear="153" priceYearOld="180" features={featBasic} />
          ) : (
            <PriceCard intro={t("land.pre.planRoomsSub")} priceMonth="10" priceMonthOld="20" priceYear="204" priceYearOld="240" features={featRoom} fromText />
          )}
        </div>
      </section>
      <section style={{ background: C.lightbrand, padding: "60px 20px" }}>
        <div style={{ ...container, maxWidth: 920, textAlign: "center" }}>
          <h2 style={h2}>{t("land.pre.empresasTitle")}</h2>
          <p style={{ marginTop: 18, fontSize: 19, lineHeight: 1.45, color: C.bdark, fontFamily: FONT_BODY, fontWeight: 600 }}>{t("land.pre.empresasDesc")}</p>
          <div style={{ marginTop: 26 }}>
            <a href="mailto:info@easyrural.net" style={{ ...btnBrand }}>{t("land.pre.contactanos")}</a>
          </div>
        </div>
      </section>
      <BannerGratis onAccess={onAccess} />
    </>
  );
}

// ═══════════ EQUIPO ════════════════════════════════════════════
function EquipoPage({ onAccess }) {
  const t = useT();
  const valores = [
    { t: t("land.eq.v1.t"), d: t("land.eq.v1.d") },
    { t: t("land.eq.v2.t"), d: t("land.eq.v2.d") },
    { t: t("land.eq.v3.t"), d: t("land.eq.v3.d") },
    { t: t("land.eq.v4.t"), d: t("land.eq.v4.d") },
    { t: t("land.eq.v5.t"), d: t("land.eq.v5.d") },
  ];
  const team = [
    { name: "Adrià González", role: t("land.eq.m1.role"), bio: t("land.eq.m1.bio"), img: "/landing/uploads_400x400_c_diseno-sin-titulo-6.png" },
    { name: "Albert Alemany", role: t("land.eq.m2.role"), bio: t("land.eq.m2.bio"), img: "/landing/uploads_400x362_c_albertalemany.png" },
  ];
  return (
    <>
      <section style={{ padding: "50px 20px", ...container }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 50, alignItems: "center" }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: 24, color: C.bdark, fontFamily: FONT_BODY }}>{t("land.eq.label")}</div>
            <h1 style={{ ...h2Brand, fontSize: 40, marginTop: 14 }}>{t("land.eq.h1")}</h1>
            <div style={{ fontWeight: 700, fontSize: 22, marginTop: 18, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.3 }}>{t("land.eq.intro1")}</div>
            <p style={{ marginTop: 14, fontSize: 18, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.4 }}>{t("land.eq.intro2")}</p>
            <div style={{ marginTop: 22, color: C.brand, fontSize: 44, lineHeight: 1.1, fontFamily: FONT_BODY }}>
              <span style={{ fontWeight: 700 }}>{t("land.hero.rural")} </span><span style={{ fontFamily: FONT_BABY, fontSize: 56 }}>{t("land.hero.si")}</span> <span style={{ fontWeight: 700 }}>{t("land.hero.digital")} </span><span style={{ fontFamily: FONT_BABY, fontSize: 56 }}>{t("land.hero.tambien")}</span>
            </div>
          </div>
          <div><img src="/landing/uploads_900x630_c_9e89c5bf28e.png" alt={t("land.eq.label")} style={{ width: "100%", height: "auto", borderRadius: 12 }} /></div>
        </div>
      </section>

      <section style={{ padding: "40px 20px", ...container }}>
        {[
          { title: t("land.eq.misionTit"), icon: "uploads_icons_300x300_c_hitos.png", text: t("land.eq.misionDesc") },
          { title: t("land.eq.visionTit"), icon: "uploads_icons_300x300_c_ojo.png", text: t("land.eq.visionDesc") },
          { title: t("land.eq.valoresTit"), icon: "uploads_icons_300x300_c_valioso.png", text: null },
        ].map((s, i) => (
          <div key={s.title} style={{ textAlign: "center", maxWidth: 820, margin: i < 2 ? "0 auto 50px" : "0 auto 20px" }}>
            <img src={`/landing/${s.icon}`} alt={s.title} style={{ width: 96, height: 96, margin: "0 auto", display: "block" }} />
            <div style={{ fontWeight: 700, fontSize: 28, color: C.brand, marginTop: 12, fontFamily: FONT_BODY }}>{s.title}</div>
            {s.text && <p style={{ marginTop: 10, fontSize: 18, color: "#000", lineHeight: 1.4, fontFamily: FONT_BODY }}>{s.text}</p>}
          </div>
        ))}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 24, marginTop: 30 }}>
          {valores.map((v) => (
            <div key={v.t} style={{ background: C.light, borderRadius: 14, padding: 28 }}>
              <div style={{ fontWeight: 700, fontSize: 22, textAlign: "center", color: C.brand, fontFamily: FONT_BODY }}>{v.t}</div>
              <p style={{ marginTop: 14, fontSize: 17, color: "#000", fontFamily: FONT_BODY, lineHeight: 1.45 }}>{v.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section style={{ background: C.lightbrand, padding: "60px 20px" }}>
        <div style={container}>
          <h2 style={{ ...h2, textAlign: "center", fontSize: 32 }}>{t("land.eq.detrasTit")}</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 32, marginTop: 40, maxWidth: 920, margin: "40px auto 0" }}>
            {team.map((m) => (
              <div key={m.name} style={{ background: "#fff", borderRadius: 14, padding: 32 }}>
                <div style={{ width: "100%", aspectRatio: "1/1", borderRadius: 12, overflow: "hidden", background: C.lightbrand }}>
                  <img src={m.img} alt={m.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                </div>
                <div style={{ marginTop: 22 }}>
                  <div style={{ color: C.brand, fontWeight: 700, fontSize: 22, fontFamily: FONT_BODY }}>{m.name}</div>
                  <div style={{ color: C.brand, fontWeight: 700, fontSize: 18, marginTop: 6, fontFamily: FONT_BODY }}>{m.role}</div>
                  <p style={{ marginTop: 14, color: "#000", fontFamily: FONT_BODY, fontSize: 17, lineHeight: 1.4, fontWeight: 600 }}>{m.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <BannerGratis onAccess={onAccess} />
    </>
  );
}

// ═══════════ FAQS ═══════════════════════════════════════════════
function FaqsPage({ onAccess }) {
  const t = useT();
  const [active, setActive] = useState(0);
  const QA = Array.from({ length: 16 }, (_, i) => [t(`land.faq.q${i + 1}`), t(`land.faq.a${i + 1}`)]);
  return (
    <>
      <section style={{ padding: "50px 20px", ...container }}>
        <h1 style={{ ...h2, fontSize: 36, fontWeight: 600, textAlign: "center", marginBottom: 30 }}>{t("land.faq.title")}</h1>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          {QA.map(([q, a], i) => {
            const open = active === i;
            return (
              <div key={i} style={{ marginBottom: 12, background: open ? C.light : C.lightbrand, padding: open ? "28px 36px" : "24px 36px", cursor: "pointer", borderRadius: 6 }} onClick={() => setActive(open ? -1 : i)}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 }}>
                  <div style={{ color: C.brand, fontFamily: FONT_BODY, fontWeight: 600, fontSize: 20 }}>{q}</div>
                  <div style={{ color: C.brand, fontWeight: 700, fontSize: 24 }}>{open ? "−" : "+"}</div>
                </div>
                {open && <div style={{ marginTop: 16, fontSize: 17, color: "#000", fontFamily: FONT_BODY, lineHeight: 1.5, maxWidth: "85%" }}>{a}</div>}
              </div>
            );
          })}
        </div>
      </section>
      <BannerGratis onAccess={onAccess} />
    </>
  );
}

// ═══════════ CONTACTO ══════════════════════════════════════════
function ContactoPage({ onAccess }) {
  const t = useT();
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "", accept: false });
  const [sent, setSent] = useState(false);
  const submit = (e) => {
    e.preventDefault();
    window.location.href = `mailto:info@easyrural.net?subject=${encodeURIComponent(form.subject || "Contacto desde la web")}&body=${encodeURIComponent(`Nombre: ${form.name}\nEmail: ${form.email}\nTeléfono: ${form.phone}\n\n${form.message}`)}`;
    setSent(true);
  };
  const update = (k, v) => setForm({ ...form, [k]: v });
  const inputStyle = { width: "100%", padding: "12px 16px", border: `1px solid ${C.lightbrand}`, borderRadius: 8, fontSize: 16, fontFamily: FONT_BODY, boxSizing: "border-box", outline: "none" };

  return (
    <>
      <section style={{ padding: "60px 20px", ...container }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 50 }}>
          <div>
            <h1 style={{ ...h2Brand, fontSize: 32, textAlign: "center", marginBottom: 30 }}>{t("land.ct.formTitle")}</h1>
            <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <input style={inputStyle} type="text" placeholder={t("land.ct.fName")} required value={form.name} onChange={(e) => update("name", e.target.value)} />
              <input style={inputStyle} type="email" placeholder={t("land.ct.fEmail")} required value={form.email} onChange={(e) => update("email", e.target.value)} />
              <input style={inputStyle} type="tel" placeholder={t("land.ct.fPhone")} value={form.phone} onChange={(e) => update("phone", e.target.value)} />
              <input style={inputStyle} type="text" placeholder={t("land.ct.fSubject")} required value={form.subject} onChange={(e) => update("subject", e.target.value)} />
              <textarea style={{ ...inputStyle, minHeight: 120, resize: "vertical" }} placeholder={t("land.ct.fMessage")} required value={form.message} onChange={(e) => update("message", e.target.value)} />
              <label style={{ display: "flex", alignItems: "flex-start", gap: 10, fontSize: 14, color: C.bdark, fontFamily: FONT_BODY }}>
                <input type="checkbox" required checked={form.accept} onChange={(e) => update("accept", e.target.checked)} style={{ marginTop: 3 }} />
                <span>{t("land.ct.fAccept")} <a href="https://easyrural.net/es/politica-de-privacidad.html" target="_blank" rel="noreferrer" style={{ color: C.brand, fontWeight: 700, textDecoration: "none" }}>{t("land.ct.fPrivacy")}</a></span>
              </label>
              <div style={{ marginTop: 8 }}>
                <button type="submit" style={{ ...btnBrand, border: "none", cursor: "pointer", padding: "12px 32px", fontSize: 18 }}>{t("land.ct.fSubmit")}</button>
              </div>
              {sent && <div style={{ background: C.lightbrand, padding: 12, borderRadius: 8, color: C.brand, fontWeight: 600, fontFamily: FONT_BODY }}>{t("land.ct.sent")}</div>}
            </form>
          </div>
          <div>
            <h2 style={{ ...h2Brand, fontSize: 32, textAlign: "center", marginBottom: 30 }}>{t("land.ct.alsoTitle")}</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
              <div style={{ background: C.lightbrand, padding: 26, borderRadius: 12 }}>
                <div style={{ color: C.brand, fontWeight: 700, fontSize: 18, fontFamily: FONT_BODY }}>📧 {t("land.ct.byEmail")}</div>
                <a href="mailto:info@easyrural.net" style={{ color: C.bdark, fontFamily: FONT_BODY, fontSize: 17, fontWeight: 600, textDecoration: "none", display: "block", marginTop: 8 }}>info@easyrural.net</a>
                <div style={{ color: "#777", fontSize: 14, marginTop: 4 }}>{t("land.foot.soporteOnline")}</div>
              </div>
              <div style={{ background: C.lightbrand, padding: 26, borderRadius: 12 }}>
                <div style={{ color: C.brand, fontWeight: 700, fontSize: 18, fontFamily: FONT_BODY }}>📞 {t("land.ct.byPhone")}</div>
                <a href="tel:+34649133541" style={{ color: C.bdark, fontFamily: FONT_BODY, fontSize: 17, fontWeight: 600, textDecoration: "none", display: "block", marginTop: 8 }}>+34 649 13 35 41</a>
                <div style={{ color: "#777", fontSize: 14, marginTop: 4 }}>{t("land.foot.de8a14")}</div>
              </div>
              <div style={{ background: C.lightbrand, padding: 26, borderRadius: 12 }}>
                <div style={{ color: C.brand, fontWeight: 700, fontSize: 18, fontFamily: FONT_BODY }}>💬 {t("land.ct.byDiscord")}</div>
                <a href="https://discord.gg/yE6h8nsG" target="_blank" rel="noreferrer" style={{ color: C.bdark, fontFamily: FONT_BODY, fontSize: 17, fontWeight: 600, textDecoration: "none", display: "block", marginTop: 8 }}>{t("land.ct.discordCta")}</a>
                <div style={{ color: "#777", fontSize: 14, marginTop: 4 }}>{t("land.ct.discordSub")}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <BannerGratis onAccess={onAccess} />
    </>
  );
}

// ═══════════ BLOG ═══════════════════════════════════════════════
function BlogPage({ onAccess }) {
  const t = useT();
  const posts = [
    { t: t("land.bl.p1.t"), d: t("land.bl.p1.d"), date: t("land.bl.p1.date"), img: "uploads_blog_400x280_c_blog1.png" },
    { t: t("land.bl.p2.t"), d: t("land.bl.p2.d"), date: t("land.bl.p2.date"), img: "uploads_blog_400x281_c_registro-unico-de-alquiler-turistico.png" },
    { t: t("land.bl.p3.t"), d: t("land.bl.p3.d"), date: t("land.bl.p3.date"), img: "uploads_blog_400x280_c_vwfrvxgnrjl.png" },
  ];
  return (
    <>
      <section style={{ padding: "60px 20px", ...container }}>
        <div style={{ textAlign: "center", maxWidth: 720, margin: "0 auto" }}>
          <h1 style={h2Brand}>{t("land.bl.title")}</h1>
          <p style={{ marginTop: 18, fontSize: 19, color: C.bdark, fontFamily: FONT_BODY }}>{t("land.bl.subtitle")}</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 24, marginTop: 48 }}>
          {posts.map((p) => (
            <div key={p.t} style={{ background: "#fff", border: `1px solid ${C.lightbrand}`, borderRadius: 14, overflow: "hidden", cursor: "pointer" }}>
              <div style={{ height: 180, overflow: "hidden" }}><img src={`/landing/${p.img}`} alt={p.t} style={{ width: "100%", height: "100%", objectFit: "cover" }} /></div>
              <div style={{ padding: 22 }}>
                <div style={{ fontSize: 13, color: C.brand, fontWeight: 600 }}>{p.date}</div>
                <h3 style={{ fontSize: 20, fontWeight: 700, color: C.bdark, marginTop: 8, fontFamily: FONT_BODY, lineHeight: 1.25 }}>{p.t}</h3>
                <p style={{ marginTop: 12, fontSize: 15, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.45 }}>{p.d}</p>
                <div style={{ marginTop: 14, color: C.brand, fontWeight: 700, fontFamily: FONT_BODY, fontSize: 15 }}>{t("land.bl.read")}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <BannerGratis onAccess={onAccess} />
    </>
  );
}

// ═══════════ FUNCIONALIDADES (4 subpáginas) ═══════════════════
function FuncionalidadPage({ pageId, onAccess }) {
  const t = useT();
  const titles = {
    reservas: t("land.nav.gestionReservas"),
    facturacion: t("land.nav.gestionFacturacion"),
    huespedes: t("land.nav.gestionHuespedes"),
    motor: t("land.nav.motorReservas"),
  };
  const mockups = {
    reservas: "uploads_900x548_c_allotjament-complet-1-mockup.png",
    facturacion: "uploads_900x548_c_facturacio-mockup.png",
    huespedes: "uploads_900x548_c_allotjmanet-habitacions-mockup.png",
    motor: "uploads_900x552_c_presentacion-proyecto-creativo-moderno-azul-1760-x-1080-px.png",
  };
  const featuresIcons = {
    reservas: ["uploads_icons_400x400_c_tarea-completada.png", "uploads_icons_400x400_c_calendario.png", "uploads_icons_400x400_c_sincronizar.png", "uploads_icons_400x400_c_geografo.png", "uploads_icons_400x400_c_factura.png"],
    facturacion: ["uploads_icons_400x400_c_factura.png", "uploads_icons_400x400_c_camion-de-reparto.png", "uploads_icons_400x400_c_caja-registradora.png", "uploads_icons_400x400_c_informe-financiero.png", "uploads_icons_400x400_c_juez.png"],
    huespedes: ["uploads_icons_400x400_c_crm.png", "uploads_icons_512x512_c_iphone.png", "uploads_icons_400x400_c_geografo.png", "uploads_icons_512x512_c_correo-electronico-abierto.png", "uploads_icons_400x400_c_juez.png"],
    motor: ["uploads_icons_400x400_c_transaccion-monetaria.png", "uploads_icons_400x400_c_personalizar.png", "uploads_icons_400x400_c_sincronizar.png", "uploads_icons_400x400_c_pago-en-linea.png", "uploads_icons_400x400_c_datos-de-busqueda.png"],
  };
  const features = [1, 2, 3, 4, 5].map((n) => ({
    icon: featuresIcons[pageId][n - 1],
    t: t(`land.fn.${pageId}.f${n}.t`),
    d: t(`land.fn.${pageId}.f${n}.d`),
  }));
  return (
    <>
      <section style={{ background: C.brand, color: "#fff", padding: "50px 20px" }}>
        <div style={{ ...container, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 50, alignItems: "center" }}>
          <div>
            <h1 style={{ ...h2, color: "#fff", fontSize: 40 }}>{titles[pageId]}</h1>
            <p style={{ marginTop: 18, fontSize: 22, fontFamily: FONT_BODY, lineHeight: 1.4 }}>{t(`land.fn.${pageId}.hero`)}</p>
            <p style={{ marginTop: 14, fontSize: 18, fontFamily: FONT_BODY, lineHeight: 1.4 }}>{t(`land.fn.${pageId}.desc`)}</p>
            <div style={{ marginTop: 26 }}>
              <button onClick={onAccess} style={{ ...btnWhite, fontSize: 20, padding: "12px 32px", fontWeight: 700, border: "none", cursor: "pointer" }}>{t("land.fn.empiezaGratis")}</button>
            </div>
          </div>
          <div><img src={`/landing/${mockups[pageId]}`} alt={titles[pageId]} style={{ width: "100%", height: "auto", borderRadius: 12 }} /></div>
        </div>
      </section>
      <section style={{ padding: "60px 20px", ...container }}>
        <div style={{ textAlign: "center", maxWidth: 720, margin: "0 auto 40px" }}>
          <h2 style={h2Brand}>{t("land.fn.queIncluye")}</h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
          {features.map((f) => (
            <div key={f.t} style={{ background: "#fff", border: `1px solid ${C.lightbrand}`, borderRadius: 14, padding: 28, display: "grid", gridTemplateColumns: "auto 1fr", gap: 20, alignItems: "center" }}>
              <img src={`/landing/${f.icon}`} alt={f.t} style={{ width: 80, height: 80, objectFit: "contain", flexShrink: 0 }} />
              <div>
                <div style={{ fontSize: 20, fontWeight: 700, color: C.brand, fontFamily: FONT_BODY }}>{f.t}</div>
                <p style={{ marginTop: 8, fontSize: 16, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.45 }}>{f.d}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <BannerGratis onAccess={onAccess} />
    </>
  );
}

// ═══════════ LOGIN ════════════════════════════════════════════
function LoginPanel({ onAuth, setPage }) {
  const t = useT();
  const [pwd, setPwd] = useState("");
  const [email, setEmail] = useState("");
  const [err, setErr] = useState(null);
  const [showDemo, setShowDemo] = useState(false);

  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      // Login real contra backend Node-RED (POST /api/auth/login)
      const API_BASE = (window.location.hostname === "localhost")
        ? "https://easyrural.duckdns.org"
        : "";
      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password: pwd }),
      });
      const body = await res.json().catch(() => null);
      if (res.ok && body?.ok && body?.token && body?.user) {
        localStorage.setItem("easyrural_user", JSON.stringify(body.user));
        localStorage.setItem("easyrural_token", body.token);
        if (body.refresh) localStorage.setItem("easyrural_refresh", body.refresh);
        localStorage.removeItem("easyrural_admin");
        onAuth();
        return;
      }
      if (res.status === 429) {
        setErr(`Demasiados intentos. Espera ${body?.retryAfterSec || 60}s.`);
        return;
      }
      // Fallback: si el backend no responde, intentar login demo local
      // (solo si el error es de red / 5xx, no si es 401 credenciales inválidas)
      if (res.status >= 500 || !body) {
        const found = findUser(email, pwd);
        if (found) {
          const { password, ...safeUser } = found;
          localStorage.setItem("easyrural_user", JSON.stringify(safeUser));
          onAuth();
          return;
        }
      }
      setErr(t("land.login.err") || "Email o contraseña incorrectos");
    } catch (netErr) {
      // Sin conexión al backend → fallback demo
      const found = findUser(email, pwd);
      if (found) {
        const { password, ...safeUser } = found;
        localStorage.setItem("easyrural_user", JSON.stringify(safeUser));
        onAuth();
        return;
      }
      setErr("Sin conexión con el servidor. Intenta más tarde.");
    } finally {
      setLoading(false);
    }
  };
  const inputStyle = { width: "100%", padding: "12px 16px", border: "1px solid #E0E0E0", borderRadius: 6, fontSize: 16, fontFamily: FONT_BODY, boxSizing: "border-box", outline: "none", background: "#F8F8F8" };
  return (
    <div style={{ background: "#F5F7F0", minHeight: "calc(100vh - 80px)", display: "flex", alignItems: "center", justifyContent: "center", padding: "60px 20px" }}>
      <div style={{ background: "#fff", padding: 48, borderRadius: 24, width: "100%", maxWidth: 560, boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
        <h2 style={{ textAlign: "center", color: C.brand, fontSize: 38, fontWeight: 700, fontFamily: FONT_BODY, margin: 0 }}>{t("land.login.title")}</h2>
        <form onSubmit={submit} style={{ marginTop: 32, display: "flex", flexDirection: "column", gap: 18 }}>
          <div>
            <label style={{ display: "block", fontSize: 17, color: C.bdark, fontWeight: 500, fontFamily: FONT_BODY, marginBottom: 8 }}>{t("land.login.email")}</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus placeholder={t("land.login.emailPh")} style={inputStyle} />
          </div>
          <div>
            <label style={{ display: "block", fontSize: 17, color: C.bdark, fontWeight: 500, fontFamily: FONT_BODY, marginBottom: 8 }}>{t("land.login.password")}</label>
            <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} required placeholder={t("land.login.passwordPh")} style={inputStyle} />
          </div>
          {err && <div style={{ color: "#E63946", fontSize: 14, fontFamily: FONT_BODY }}>{err}</div>}
          <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
            <button type="submit" disabled={loading} style={{ ...btnBrand, padding: "12px 36px", fontSize: 14, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, border: "none", cursor: loading ? "wait" : "pointer", opacity: loading ? 0.7 : 1 }}>{loading ? "..." : t("land.login.btn")}</button>
          </div>
        </form>
        <div style={{ marginTop: 28, fontSize: 17, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.4 }}>
          {t("land.login.terms1")} <a href="https://easyrural.net/es/terminos-y-condiciones.html" target="_blank" rel="noreferrer" style={{ color: C.brand, textDecoration: "none", fontWeight: 600 }}>{t("land.foot.terminos")}</a> {t("land.login.terms2")} <a href="https://easyrural.net/es/politica-de-privacidad.html" target="_blank" rel="noreferrer" style={{ color: C.brand, textDecoration: "none", fontWeight: 600 }}>{t("land.login.privacy")}</a>.
        </div>
        <div style={{ textAlign: "center", marginTop: 22, fontSize: 17, color: C.bdark, fontFamily: FONT_BODY }}>
          {t("land.login.noAccount")} <button onClick={() => setPage("register")} style={{ background: "none", border: "none", color: C.brand, fontFamily: FONT_BODY, fontSize: 17, fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}>{t("land.login.createAccount")}</button>
        </div>

        {/* Panel colapsable con credenciales de la demo */}
        <div style={{ marginTop: 20, borderTop: "1px dashed #DCE7CF", paddingTop: 16 }}>
          <button type="button" onClick={() => setShowDemo(v => !v)}
            style={{ background: "none", border: "none", color: C.brand, fontFamily: FONT_BODY, fontSize: 13, fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}>
            {showDemo ? "▼ Ocultar credenciales demo" : "▶ Ver credenciales demo"}
          </button>
          {showDemo && (
            <div style={{ marginTop: 12, background: "#F8FBF3", border: "1px solid #DCE7CF", borderRadius: 8, padding: 12, fontFamily: "monospace", fontSize: 12, color: "#283226", lineHeight: 1.7 }}>
              {DEMO_USERS.map(u => (
                <div key={u.email}>
                  <b>{u.role === "admin" ? "ADMIN" : u.nombre}</b> — {u.email} / {u.password}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ═══════════ REGISTER ═════════════════════════════════════════
function RegisterPanel({ setPage }) {
  const t = useT();
  const [form, setForm] = useState({ name: "", email: "", password: "", confirm: "" });
  const [err, setErr] = useState(null);
  const [ok, setOk] = useState(false);
  const submit = (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) { setErr(t("land.reg.passMismatch")); return; }
    if (form.password.length < 8) { setErr(t("land.reg.passShort")); return; }
    window.location.href = `mailto:info@easyrural.net?subject=${encodeURIComponent("Solicitud de cuenta — Módulo Energía")}&body=${encodeURIComponent(`Nombre: ${form.name}\nEmail: ${form.email}\n\nSolicito el alta en el Módulo Energía.`)}`;
    setOk(true);
  };
  const inputStyle = { width: "100%", padding: "12px 16px", border: "1px solid #E0E0E0", borderRadius: 6, fontSize: 16, fontFamily: FONT_BODY, boxSizing: "border-box", outline: "none", background: "#F8F8F8" };
  return (
    <div style={{ background: "#F5F7F0", minHeight: "calc(100vh - 80px)", display: "flex", alignItems: "center", justifyContent: "center", padding: "60px 20px" }}>
      <div style={{ background: "#fff", padding: 48, borderRadius: 24, width: "100%", maxWidth: 640, boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
        <h2 style={{ textAlign: "center", color: C.brand, fontSize: 38, fontWeight: 700, fontFamily: FONT_BODY, margin: 0 }}>{t("land.reg.title")}</h2>
        <form onSubmit={submit} style={{ marginTop: 32, display: "flex", flexDirection: "column", gap: 18 }}>
          <div>
            <label style={{ display: "block", fontSize: 17, color: C.bdark, fontWeight: 500, fontFamily: FONT_BODY, marginBottom: 8 }}>{t("land.reg.name")}</label>
            <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required autoFocus placeholder={t("land.reg.namePh")} style={inputStyle} />
          </div>
          <div>
            <label style={{ display: "block", fontSize: 17, color: C.bdark, fontWeight: 500, fontFamily: FONT_BODY, marginBottom: 8 }}>{t("land.login.email")}</label>
            <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required placeholder={t("land.login.emailPh")} style={inputStyle} />
          </div>
          <p style={{ fontSize: 15, color: C.bdark, fontFamily: FONT_BODY, padding: "0 4px", lineHeight: 1.4 }}>{t("land.reg.passwordHelp")}</p>
          <div>
            <label style={{ display: "block", fontSize: 17, color: C.bdark, fontWeight: 500, fontFamily: FONT_BODY, marginBottom: 8 }}>{t("land.login.password")}</label>
            <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required placeholder={t("land.login.passwordPh")} style={inputStyle} />
          </div>
          <div>
            <label style={{ display: "block", fontSize: 17, color: C.bdark, fontWeight: 500, fontFamily: FONT_BODY, marginBottom: 8 }}>{t("land.reg.confirm")}</label>
            <input type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required placeholder={t("land.reg.confirmPh")} style={inputStyle} />
          </div>
          {err && <div style={{ color: "#E63946", fontSize: 14, fontFamily: FONT_BODY }}>{err}</div>}
          {ok && <div style={{ color: C.brand, fontSize: 15, fontFamily: FONT_BODY, fontWeight: 600 }}>{t("land.reg.sent")}</div>}
          <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
            <button type="submit" style={{ ...btnBrand, padding: "12px 36px", fontSize: 14, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, border: "none", cursor: "pointer" }}>{t("land.reg.btn")}</button>
          </div>
        </form>
        <div style={{ marginTop: 28, fontSize: 17, color: C.bdark, fontFamily: FONT_BODY, lineHeight: 1.4 }}>
          {t("land.reg.terms1")} <a href="https://easyrural.net/es/terminos-y-condiciones.html" target="_blank" rel="noreferrer" style={{ color: C.brand, textDecoration: "none", fontWeight: 600 }}>{t("land.foot.terminos")}</a> {t("land.login.terms2")} <a href="https://easyrural.net/es/politica-de-privacidad.html" target="_blank" rel="noreferrer" style={{ color: C.brand, textDecoration: "none", fontWeight: 600 }}>{t("land.login.privacy")}</a>.
        </div>
        <div style={{ textAlign: "center", marginTop: 22, fontSize: 17, color: C.bdark, fontFamily: FONT_BODY }}>
          {t("land.reg.haveAccount")} <button onClick={() => setPage("login")} style={{ background: "none", border: "none", color: C.brand, fontFamily: FONT_BODY, fontSize: 17, fontWeight: 700, cursor: "pointer", textDecoration: "underline" }}>{t("land.reg.login")}</button>
        </div>
      </div>
    </div>
  );
}

// ═══════════ LANDING PAGE ROOT ══════════════════════════════════
export default function LandingPage({ onAuth }) {
  const [page, setPage] = useState("home");
  const navigate = (id) => { setPage(id); window.scrollTo(0, 0); };
  const onLogin = () => navigate("login");
  const onRegister = () => navigate("register");

  const renderPage = () => {
    switch (page) {
      case "home": return <HomePage onAccess={onRegister} />;
      case "precios": return <PreciosPage onAccess={onRegister} />;
      case "equipo": return <EquipoPage onAccess={onRegister} />;
      case "faqs": return <FaqsPage onAccess={onRegister} />;
      case "contacto": return <ContactoPage onAccess={onRegister} />;
      case "blog": return <BlogPage onAccess={onRegister} />;
      case "reservas":
      case "facturacion":
      case "huespedes":
      case "motor":
        return <FuncionalidadPage pageId={page} onAccess={onRegister} />;
      case "login": return <LoginPanel onAuth={onAuth} setPage={navigate} />;
      case "register": return <RegisterPanel setPage={navigate} />;
      default: return <HomePage onAccess={onRegister} />;
    }
  };

  return (
    <div style={{ fontFamily: FONT_BODY, background: "#fff", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <link href="https://fonts.googleapis.com/css2?family=Baloo+2:wght@400;500;600;700;800&family=Oooh+Baby&display=swap" rel="stylesheet" />
      <Header currentPage={page} setPage={navigate} onAccess={onLogin} onRegister={onRegister} />
      <main style={{ flex: 1 }}>{renderPage()}</main>
      <Footer />
    </div>
  );
}
